import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToSection } from "./Reveal";

const NAV = [
  { label: "Home", hash: "#home", testid: "nav-home-link" },
  { label: "Schedule", hash: "#schedule", testid: "nav-schedule-link" },
  { label: "Service Area", hash: "#area", testid: "nav-area-link" },
  { label: "Gallery", hash: "#gallery", testid: "nav-gallery-link" },
  { label: "Contact Us", hash: "#contact", testid: "nav-contact-link" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  const go = (hash) => {
    setOpen(false);
    scrollToSection(hash);
  };

  return (
    <header
      data-testid="site-header"
      className="fixed inset-x-0 top-0 z-50 bg-white text-royal-dark"
    >
      <div className="relative flex h-16 w-full items-center justify-center px-6">
        <button
          data-testid="header-wordmark"
          onClick={() => window.__lenis?.scrollTo(0)}
          className="absolute left-6 top-1/2 -translate-y-1/2 transition-opacity duration-200 hover:opacity-70"
          aria-label="Trumbull Paving Co. — back to top"
        >
          <img
            src="/tcc-logo.png"
            alt="Trumbull Contracting Corporation logo"
            className="h-10 w-auto"
          />
        </button>

        <div
          data-testid="header-name"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 select-none"
        >
          <span className="block text-center leading-none">
            <span className="block font-display text-xl font-bold uppercase tracking-tight text-black">
              Trumbull
            </span>
            <span className="mt-0.5 flex items-center justify-center gap-1 font-display text-[10px] font-semibold uppercase tracking-[0.12em] text-royal-dark">
              <span className="h-px w-3 bg-royal-dark/80" />
              Paving Co.
              <span className="h-px w-3 bg-royal-dark/80" />
            </span>
          </span>
        </div>

        <nav
          className="absolute right-6 hidden items-center gap-5 lg:flex xl:gap-7"
          data-testid="desktop-nav"
        >
          {NAV.map((item) => (
            <button
              key={item.hash}
              data-testid={item.testid}
              onClick={() => go(item.hash)}
              className="group relative font-mono text-xs uppercase tracking-[0.2em] text-royal-dark transition-colors duration-200 hover:text-royal-dark/60"
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-royal-dark transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="absolute right-6 top-1/2 flex -translate-y-1/2 items-center gap-3">
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            className="text-royal-dark transition-colors duration-200 hover:text-royal-dark/60 lg:hidden"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="border-t border-royal-dark/10 bg-white px-6 py-4 text-royal-dark lg:hidden"
        >
          {NAV.map((item) => (
            <button
              key={item.hash}
              data-testid={`mobile-${item.testid}`}
              onClick={() => go(item.hash)}
              className="block w-full py-3 text-left font-mono text-sm uppercase tracking-[0.2em] text-royal-dark transition-colors duration-200 hover:text-royal-dark/60"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
